import RenderManager from "../rendering/render-manager";
import getVWKey from "../helpers/getVWKey";
import Utils from "../utils";
import * as Events from "../utils/events";
import EntranceExit from "./EntranceExit";
import SlideManager from "../utils/slide-manager";

const CurveParams = {
  segmentLength: 10, // how many seconds between two points
  subdivisionCount: 25, // detail of a curve between two points
};

let tooltipModel = {
  opacity: 1,
  body: [
    {lines: ["Track: 600 m"]},
    {lines: ["Displacement: 600 m"]},
    {lines: ["Velocity: 30 m/s"]},
    {lines: ["Acceleration: 0 m/s²"]}
  ],
  labelColors: [
    {borderColor: "rgb(230, 230, 230)", backgroundColor: "#1bab93"},
    {borderColor: "rgb(230, 230, 230)", backgroundColor: "#003ded"},
    {borderColor: "rgb(230, 230, 230)", backgroundColor: "#fa3e2e"},
    {borderColor: "rgb(230, 230, 230)", backgroundColor: "#ff8c2f"}
  ],
  caretX: 0,
  caretY: 0
};

const rW = () => Q3.browserCapabilities.isMobile ? 30 : 60;
const rH = () => rW() * 1.45;

let datasets = [
  [300, 500, 0, 250, 300, 180, 300],
  [0, 300, 600, 100, 100, 100, 100],
];
let chartData = {
  type: 'scatter',
  data: {
    datasets: [
      {
        yAxisID: "y-axis-0",
        label: "Track",
        units: "m",
        symbol: "Track",
        showDisplay: false,
        showLine: true,
        data: [{ x: 0, y: 0 }, { x: 0, y: 0 }],
        borderWidth: 15,
        borderColor: "#1bab93",
        backgroundColor: "transparent",
        lineTension: 0,
        pointBorderColor: "white",
        pointBackgroundColor: "#1bab93",
        pointHitRadius: 30,
        pointRadius: 7,
        pointBorderWidth: 2,
        pointHoverRadius: 10,
        pointHoverBorderWidth: 2,
        pointHoverBackgroundColor: "#1bab93",
      },
      {
        yAxisID: "y-axis-0",
        label: "Displacement",
        units: "m",
        symbol: "s",
        data: [{ x: 0, y: 0 }, { x: 0, y: 0 }],
        fill: false,
        showLine: true,
        lineTension: 0,
        backgroundColor: "rgba(0, 61, 237, 0.3)",
        borderColor: "#003ded",
        pointBorderColor: "white",
        borderWidth: 10,
        pointBackgroundColor: "#003ded",
        pointHitRadius: 30,
        pointRadius: 7,
        pointBorderWidth: 2,
        pointHoverRadius: 10,
        pointHoverBorderWidth: 2,
        pointHoverBackgroundColor: "#003ded",
      },
      {
        yAxisID: "y-axis-1",
        label: "Velocity",
        units: "m/s",
        symbol: "v",
        data: [{ x: 0, y: 0 }, { x: 0, y: 0 }],
        fill: true,
        showLine: true,
        lineTension: 0,
        backgroundColor: "rgba(250, 62, 46, 0.25)",
        borderColor: "#fa3e2e",
        pointBorderColor: "white",
        borderWidth: 10,
        pointRadius: 0,
        pointHitRadius: 0,
        pointBackgroundColor: "#fa3e2e",
        pointHoverRadius: 7,
        pointHoverBorderWidth: 2,
        pointHoverBackgroundColor: "#fa3e2e",
      },
      {
        yAxisID: "y-axis-1",
        label: "Acceleration",
        units: "m/s²",
        symbol: "a",
        data: [{ x: 0, y: 0 }, { x: 0, y: 0 }],
        fill: true,
        showLine: true,
        lineTension: 0,
        backgroundColor: "rgba(255, 140, 47, 0.25)",
        borderColor: "#ff8c2f",
        pointBorderColor: "white",
        borderWidth: 10,
        pointRadius: 0,
        pointHitRadius: 0,
        pointBackgroundColor: "#ff8c2f",
        pointHoverRadius: 7,
        pointHoverBorderWidth: 2,
        pointHoverBackgroundColor: "#ff8c2f",
      }
    ]
  },
  options: {
    devicePixelRatio: window.devicePixelRatio,
    layout: {
      padding: {
        left: 10,
        right: 10,
        top: 30,
        bottom: 0
      }
    },
    responsive: true,
    maintainAspectRatio: false,
    aspectRatio: 1.4,
    legend: {
      display: false
    },
    tooltips: {
      // titleFontSize: 0,
      bodyFontSize: 20,
      mode: 'index',
      position: 'nearest',
      // intersect: true,
      enabled: false,
    },
    elements: {
      line: {
        // tension: 0 // disables bezier curves
      },
    },
    scales: {
      yAxes: [{
        id: "y-axis-0",
        color: "white",
        display: true,
        scaleLabel: {
          display: true,
          labelString: "Displacement (m)",
          fontColor: "#fff",
          fontSize: Math.min(window.innerWidth / 40, 14),
          padding: 0,
        },
        gridLines: {
          drawOnChartArea: false,
          color: "white"
        },
        ticks: {
          padding: 60,
          lineColor: "white",
          fontColor: "white",
          fontSize: Math.min(window.innerWidth / 40, 16),
          fontWeight: "bold",
          min: -100,
          max: 600,
          beginAtZero: true,
        },
      },
        {
          id: "y-axis-1",
          color: "white",
          display: "auto",
          position: "right",
          scaleLabel: {
            display: true,
            labelString: "Velocity (m/s)",
            fontColor: "#fff",
            fontSize: Math.min(window.innerWidth / 40, 14),
            padding: 0,
          },
          gridLines: {
            drawOnChartArea: false,
            color: "white"
          },
          ticks: {
            lineColor: "white",
            fontColor: "white",
            fontSize: Math.min(window.innerWidth / 40, 16),
            fontWeight: "bold",
            min: -20,
            max: 120,
            beginAtZero: true
          }
        },
      ],
      xAxes: [{
        id: "x-axis-0",
        type: "linear",
        display: true,
        scaleLabel: {
          display: true,
          labelString: "Time (s)",
          fontColor: "#fff",
          fontSize: Math.min(window.innerWidth / 40, 14),
          padding: 0,
        },
        gridLines: {
          color: "white",
          drawOnChartArea: false,
        },
        ticks: {
          fontColor: "white",
          fontSize: Math.min(window.innerWidth / 40, 16),
          fontWeight: "bold",
        }
      }]
    },
  }
};

const MotionLabel = {
  text: {
    accelerating: "Accelerating",
    slowingDown: "Slowing down",
    stationary: "Stationary",
    constantSpeed: "Constant speed",
  },
};


class RollerCoaster {

  constructor(options, parentLayer, uuid = THREE.Math.generateUUID()) {

    this.getVWSize = getVWKey;

    /* COMMON 2D ELEMENTS DEFINITION */
    this.uuid = uuid;
    this.type = "2DObject";
    this.type2d = "RollerCoaster";
    this.isMounted = false;
    this.multiSelectable = true;
    this.index = options.index;
    this.inLetterbox = Boolean(options.inLetterbox !== false);
    this.parentLayer = parentLayer;
    this.data = Q3.data.layers.layers2D[this.parentLayer.uuid].objects[this.uuid];
    this.options = options;
    this.legend = options.legend || {"0": {}};
    this.animationFrame = null;
    //dom insertion

    /* SPECIFIC 2D ELEMENTS PARAMETERS */
    this.y = options.y;
    this.x = options.x;
    this.src = options.filename;
    this.width = options.width || 0.4;
    this.height = options.height || 0.4;

    let thresholds = options.thresholds || {};
    this.thresholds = {
      acceleration: 'acceleration' in thresholds ? thresholds.acceleration : 0.5,
      velocity: 'velocity' in thresholds ? thresholds.velocity : 0.25,
    };

    let initialData = {
      x: options.x,
      y: options.y,
      width: options.width || 0.40,
      height: options.height || 0.35,
    };

    this.sizeSm = JSON.parse(JSON.stringify(options.sizeSm ? options.sizeSm : initialData));
    this.sizeLg = JSON.parse(JSON.stringify(options.sizeLg ? options.sizeLg : initialData));

    if (Q3.isReady) {
      this.enterExitCtrl = new EntranceExit(this, [this.domElement]);
      this.enterExitCtrl.init(options);
    } else {
      Q3.Events.listen("tourReady", () => {
        this.enterExitCtrl = new EntranceExit(this, [this.domElement]);
        this.enterExitCtrl.init(options);
      })
    }

    if (!this.data.datasets) {
      this.data.datasets = datasets.map(dataset => dataset.slice())
    }
    this.datasets = this.data.datasets;
    this.chartData = JSON.parse(JSON.stringify(chartData));

    let subdivCount = CurveParams.subdivisionCount;
    let pointRadius = ctx => ctx.dataIndex%subdivCount === 0 ? 7 : 0;
    let pointHoverRadius = ctx => ctx.dataIndex%subdivCount === 0 ? 10 : 0;
    let pointHitRadius = ctx => ctx.dataIndex%subdivCount === 0 ? 30 : 0;
    let trackDataset = this.chartData.data.datasets[0];
    let displacementDataset = this.chartData.data.datasets[1];
    trackDataset.pointRadius = pointRadius;
    trackDataset.pointHoverRadius = pointHoverRadius;
    trackDataset.pointHitRadius = pointHitRadius;
    displacementDataset.pointRadius = pointRadius;
    displacementDataset.pointHoverRadius = pointHoverRadius;
    displacementDataset.pointHitRadius = pointHitRadius;
    this.chartData.data.datasets[2].pointHitRadius = pointHitRadius;
    this.chartData.data.datasets[3].pointHitRadius = pointHitRadius;

    this.chartData.options.scales.xAxes[0].ticks.callback = t => t+'s';

    this.domElement = null;
    this.displays = {};
    this.buttons = {};
    this.dragging = null;
    this.wrapper = null;
    this.scale = "";
    this.index = 0;
    this.pointsCount = options.pointsCount || datasets[0].length;
    this.chartData.data.datasets.forEach((set) => {
      set.data = set.data.slice(0, this.pointsCount);
      set.borderWidth = set.borderWidth * (Q3.browserCapabilities.isMobile ? 0.5 : 1)
    });
    this.chartInstance = null;
    this.rollerCount = 1;
    this.rollers = [];
    this.legendButtons = {};
    this.maxY = 600;
    this._pos = false;
    this.startSpeed = 0.1;
    this.speed = 0.1;
    this.isPlaying = false;
    // this.data = [];

    this.onDragStart = this.onDragStart.bind(this);
    this.onDrag = this.onDrag.bind(this);
    this.onDragStop = this.onDragStop.bind(this);
    this.setRollerPosition = this.setRollerPosition.bind(this);

    this.domElement = document.createElement("div"); //root
    this.domElement.classList.add("rollercoaster");
    this.parentLayer.domElement.appendChild(this.domElement);
    this.canvas = document.createElement("canvas");
    this.wrapper = document.createElement("div");
    this.domElement.appendChild(this.wrapper);
    this.wrapper.appendChild(this.canvas);
    this.wrapper.classList.add("chart-wrapper");
    this.bgImg = document.createElement("div");
    this.bgImg.classList.add("chart-bg");
    this.bgGrid = document.createElement("div");
    this.bgGrid.classList.add("chart-bg-grid");
    this.bgTrack = document.createElement("div");
    this.bgTrack.classList.add("chart-bg-track");
    this.lineCnt = document.createElement("div");
    this.lineCnt.classList.add("roller-line-cnt");
    this.wrapper.appendChild(this.bgImg);
    this.wrapper.appendChild(this.bgGrid);
    this.wrapper.appendChild(this.bgTrack);
    this.wrapper.appendChild(this.lineCnt);
    Q3.editMode && this.domElement.addEventListener('click', e => {
      if (Q3.isSelecting2dObject) return;

      if (this.isDragging) return;
      if ((e.ctrlKey || e.metaKey) && Q3.selected.multiSelectable) {
        if (Q3.selected.target) {
          return;
        }
        Q3.multiSelect[Q3.selected.uuid] = Q3.selected;
        Q3.multiSelect[this.uuid] = this;
        Events.fire('selectchange');
      } else {
        Q3.multiSelect = {};
        Q3.selected = this;
        Events.fire('selectchange');
        RenderManager.activeCamera.update = true;
        Events.fire('dragstart', e);
      }
    }, false);


    this.redraw = this.redraw.bind(this);
    this.setSlideData = this.setSlideData.bind(this);
    const {width, height} = RenderManager.getSize();
    this.redraw(width, height);

    if (!Q3.isFullyLoaded) {
      Events.listen('tourReady', () => {
        this.init();
        this.handleListeners(true);
      })
    } else {
      this.init();
      this.handleListeners(true);

    }

  }

  handleListeners(add) {
    Events[add ? "listen" : "unlisten"]("viewportchanged", this.redraw);
    Events[add ? "listen" : "unlisten"]("splashremoved", this.redraw);
    Events[add ? "listen" : "unlisten"]("slidechange", this.setSlideData);
  }

  updateSize() {
    let rect = this.chartInstance.chartArea;
    let cW = this.chartInstance.canvas.width;
    // let cH = this.chartInstance.canvas.offsetHeight;

    this.bgImg.style.width = cW + "px";
    this.bgImg.style.height = rect.bottom - rect.top + "px";
    this.bgImg.style.left = 0;
    this.bgImg.style.bottom = this.bgGrid.style.bottom = this.bgTrack.style.bottom = this.lineCnt.style.bottom  = this.scaleY.margins.bottom + "px";

    this.bgGrid.style.width = this.lineCnt.style.width = rect.right - rect.left + "px";
    this.bgGrid.style.height = this.lineCnt.style.height = this.bgTrack.style.height = rect.bottom - rect.top + "px";
    this.bgGrid.style.left = this.lineCnt.style.left = rect.left + "px";
    // this.bgGrid.style.bottom = this.lineCnt.style.bottom = rect.top - rect.bottom + "px";
    this.bgTrack.style.width = rW() + "px";
    this.bgTrack.style.right = (this.scaleX.width+this.scaleX.margins.right+this.scaleY.options.gridLines.tickMarkLength) + "px";
    this.rollers.forEach(r => {r.style.width = rW() + "px"; r.style.height = rH() + "px"});
    // this.bgTrack.style.bottom = rect.top - rect.bottom + "px";
  }

  setSlideData() {
    let data = Q3.data.layers.layers2D[this.parentLayer.uuid].objects[this.uuid];
    let legendMap = ["track", "displacement", "speed", "acceleration"];
    let slide = SlideManager.activeSlide;
    if (data.legend && data.legend[slide] && Object.keys(data.legend[slide]).length) {
      legendMap.forEach((k, i) => {
        this.setLegend(i, data.legend[slide][k] !== false);
        this.legendButtons[this.chartInstance.data.datasets[i].label].style.display = data.legend[slide][k] !== false ? "block" : "none"
      });
    } else {
      legendMap.forEach((l, i) => {
        this.setLegend(i, true);
        this.legendButtons[this.chartInstance.data.datasets[i].label].style.display = "block"
      });
    }

    this.playPause(Boolean(data.isPlaying && data.isPlaying[slide]));

    setTimeout(() => { //chart animation delay
      this.update();
      this.setRollerPosition()
      this.updateSize();
    }, 300)
  }

  playLeavingAnimation() {
    this.enterExitCtrl.playLeave();
  }

  cancelLeavingAnimation() {
    this.enterExitCtrl.cancelLeave();
  }


    init() {
        awaitLib().then(() => {
            Events.listen("enterslide", () => {
                this.customTooltip();
            });

            this.ctx = this.canvas.getContext('2d');
            this.update.bind(this);

            if (Q3.browserCapabilities.isMobile) { this.chartData.options.scales.yAxes[0].ticks.padding = 30; }

            this.chartData.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return data.datasets[tooltipItem.datasetIndex].label + ": " + tooltipItem.yLabel.toFixed(0) + " " + data.datasets[tooltipItem.datasetIndex].units;
                },
            };

            // this.chartData.options.tooltips.custom = this.customTooltip.bind(this);
            window.chartInstance = this.chartInstance = new Chart(this.ctx, this.chartData);

            this.scaleX = this.chartInstance.scales["x-axis-0"];
            this.scaleY = this.chartInstance.scales["y-axis-0"];
            this.chartInstance.chart.canvas.addEventListener("mousedown", this.onDragStart);
            this.chartInstance.chart.canvas.addEventListener("touchstart", this.onDragStart);
            if (!Q3.editMode) {
                window.addEventListener("resize", () => {
                    clearTimeout(this.updateTimeout)
                    this.updateTimeout = setTimeout(() => {
                        this.update();
                        this.updateSize();
                        !this.isPlaying && this.setRollerPosition();
                    }, 100)
                })
            }

            this.addRollers();
            this.addMotionLabel();

            this.addControls();

            this.setSlideData();

            setTimeout(() => {
                this.update();
                this.setRollerPosition()
            }, 300)
        });
  }

  customTooltip(tooltipModel = {opacity: 0}) {
    if (Q3.editMode || this.isDeleted) return;
    // Tooltip Element
    let tooltipEl = this.tooltipEl = document.getElementById("chartjs-tooltip");
    this.tooltipEl = tooltipEl;
    // Create element on first render
    if (!tooltipEl) {
      tooltipEl = document.createElement('div');
      tooltipEl.id = 'chartjs-tooltip';
      tooltipEl.className = 'chartjs-tooltip';
      tooltipEl.innerHTML = '<div class="tooltip-root"></div>';
      this.tooltipEl = tooltipEl;
      this.setTooltipPosition( this.chartInstance.chartArea.left + 5, this.chartInstance.chartArea.top + 25 );
      document.body.appendChild(tooltipEl);
    } else {
      this.setTooltipPosition( this.chartInstance.chartArea.left + 5, this.chartInstance.chartArea.top + 25 );
    }

    // Hide if no tooltip
    // if (tooltipModel.opacity === 0) {
    //   tooltipEl.style.opacity = 0;
    //   return;
    // }

    // Set Text
    if (tooltipModel.body) {
      let bodyLines = tooltipModel.body.filter(i => !i.hidden).map((i) => i.lines);
      let labelColors = tooltipModel.labelColors.filter((c, i) => !tooltipModel.body[i].hidden)
      let innerHtml = '';
      bodyLines.forEach((body, i) => {
        let colors = labelColors[i];
        let style = 'background:' + colors.backgroundColor;
        style += '; border-color:' + colors.borderColor;
        style += '; border-width: 2px';
        body = body[0].split(" ");
        let num = parseFloat(body[1]);
        if (!isNaN(num)) {
          if (num === -0) { num = 0 }
          if (num > 0 ) {
            num = '<span style="color: #00ef00"> +' + num + '</span>';
          } else {
            num = '<span style="color: red"> ' + num + '</span>';
          }
          let span = '<span class="color" style="' + style + '"></span>';
          innerHtml += '<div class="tooltip-row">' + span + body[0] + num + body[2] + '</div>';
        }
      });
      // innerHtml += '</div>';

      let tooltipRoot = tooltipEl.querySelector('.tooltip-root');
      tooltipRoot.innerHTML = innerHtml;
    }

    // let cY = tooltipModel.caretY;
    // let cX = tooltipModel.caretX;
    tooltipEl.style.opacity = 1;

    // if (!this.dragging) {
    //   this.setTooltipPosition(cX, cY, canvasPos);
    // }

    // tooltipEl.style.transform = this.calcTooltipAlign(cX, cY, canvasPos.width, canvasPos.height);
  }

  setTooltipPosition(cX, cY, canvasPos) {
    if (Q3.editMode) return;
    if (!canvasPos) canvasPos = this.canvas.getBoundingClientRect();
    this.tooltipEl.style.left = canvasPos.left + window.pageXOffset + cX + 'px';
    this.tooltipEl.style.top = canvasPos.top + window.pageYOffset + cY + 'px';
  }

  calcTooltipAlign(cX, cY, w, h) {
    return "translate(" + (cX < w * 0.333 ? "0" : cX < w * 0.666 ? "-50" : "-100") + "% ," + (cY < h * 0.333 ? "0" : (cY < h * 0.666 && (cX < w * 0.333 || cX > w * 0.666)) ? "-50" : "-100") + "%)"
  }

  setLegend(i, visible) {
    if (visible === undefined) {
      visible = !this.legendButtons[this.chartInstance.data.datasets[i].label].classList.contains("active");
    }
    this.legendButtons[this.chartInstance.data.datasets[i].label].classList[visible ? "add" : "remove"]("active");
    this.chartInstance.getDatasetMeta(i).hidden = !visible;
    if (i === 1) {
      this.rollers.forEach(r => r.style.display = visible ? "block" : "none");
      // this.playbackLineX.style.display = visible ? "none" : "block";
      this.rollerTip.style.display = visible ? "block" : "none";
      this.rollerIsVisible = visible;
    }
    this.displays[this.chartInstance.data.datasets[i].label].style.display = visible ? "block" : "none";
    this.chartInstance.update();
  }

  addControls() {
    let buttonsCnt = document.createElement("div");
    buttonsCnt.classList.add("roller-buttons");
    this.domElement.appendChild(buttonsCnt);
    this.legendButtons = {};

    this.playPauseBtn = document.createElement("button");
    this.playPauseBtn.classList.add("play-pause-btn");
    this.playPauseBtn.innerHTML = "PLAY ▶";
    this.playPauseBtn.addEventListener("click", () => {
      this.playPause();
    });
    buttonsCnt.appendChild(this.playPauseBtn);
    this.chartData.data.datasets.forEach((d, i) => {
      this.displays[d.label] = document.createElement("div");
      this.displays[d.label].classList.add("value-display");
      d.showDisplay === false && this.displays[d.label].classList.add("disabled");
      this.displays[d.label].innerHTML = '<span>' + d.symbol + ' = 0 ' + d.units + '</span>';
      this.displays[d.label].style.color = d.pointBackgroundColor;
      buttonsCnt.appendChild(this.displays[d.label]);
    });
    let separator = document.createElement("div");
    separator.style.marginTop = "auto";
    buttonsCnt.appendChild(separator);
    this.chartData.data.datasets.forEach((d, i) => {
      let button = document.createElement("button");
      button.innerHTML = d.label;
      button.style.backgroundColor = d.pointBackgroundColor;
      button.classList.add("active");
      button.classList.add("legend");
      d.showDisplay === false && button.classList.add("disabled");
      buttonsCnt.appendChild(button);
      button.addEventListener("click", () => {
        this.setLegend(i)
      });
      this.legendButtons[d.label] = button;
    });
  }

  playPause(state) {
    this.isPlaying = state !== undefined ? state : !this.isPlaying;
    this.playPauseBtn.innerHTML = this.isPlaying ? "STOP ◼" : "PLAY ▶";
    if (this.isPlaying) {
      this.animationFrame = requestAnimationFrame(this.setRollerPosition);
    } else {
      cancelAnimationFrame(this.animationFrame);
    }
  }

  addRollers() {
    for (let i = 0; i < this.rollerCount; i++) {
      let roller = document.createElement("div");
      roller.classList.add("roller");
      this.wrapper.appendChild(roller);
      this.rollers.push(roller);
      roller.style.width = rW() + "px";
      roller.style.height = rH() + "px";
      roller.style.display = "none";
    }

    this.rollerTip = document.createElement("div");
    this.rollerTip.classList.add("roller-tip");
    this.rollerTip.style.display = "none";

    // let line = document.createElement("div");
    // line.classList.add("roller-line");
    this.playbackLineX = document.createElement("div");
    this.playbackLineX.classList.add("roller-line");
    this.playbackLineX.classList.add("playback-line");
    // this.playbackLineX.style.display = "none";
    this.playbackLineY = document.createElement("div");
    this.playbackLineY.classList.add("roller-line");
    this.playbackLineY.classList.add("playback-line");
    this.playbackLineY.classList.add("horizontal");
    this.canvas.addEventListener("mousemove", (e) => {
      if (!this.parentLayer.visible) return;
      let min = 0;
      let max = this.chartInstance.chartArea.right - this.chartInstance.chartArea.left - window.devicePixelRatio;
      let left = e.offsetX - this.chartInstance.chartArea.left;
      left < min && (left = min);
      left > max && (left = max);

      this.calcPointData(left);

      (!this.isPlaying) && this.customTooltip.call(this, this.tooltipModel);
    });
    this.lineCnt.appendChild(this.playbackLineX);
    this.lineCnt.appendChild(this.playbackLineY);

    this.wrapper.appendChild(this.rollerTip);
  }

  addMotionLabel() {
    this.motionLabel = document.createElement("div");
    this.motionLabel.classList.add("roller-tip");
    this.wrapper.appendChild(this.motionLabel);

    this.canvas.addEventListener("mousemove", (e) => {
      if (!this.parentLayer.visible) return;
      let rect = this.canvas.getBoundingClientRect();

      let mouseScreenPos = { x: e.offsetX, y: e.offsetY };
      let mouseGraphPos = this.getGraphFromScreenPosition(mouseScreenPos);
      let x = mouseGraphPos.x;
      let y = this.getGraphValue(this.chartInstance.data.datasets[1].data, x);
      let valueGraphPos = { x, y };
      let valueScreenPos = this.getScreenFromGraphPosition(valueGraphPos);

      let show = false;

      if (Math.abs(valueScreenPos.y-mouseScreenPos.y) < 40) {
        this.motionLabel.style.left = valueScreenPos.x + "px";
        this.motionLabel.style.top = (valueScreenPos.y-38) + "px";

        let velocity = this.getGraphValue(this.chartInstance.data.datasets[2].data, x);
        let acceleration = this.getGraphValue(this.chartInstance.data.datasets[3].data, x);

        let text;

        if (Math.abs(acceleration) > this.thresholds.acceleration) {
          if (Math.sign(acceleration)*Math.sign(velocity) === -1) {
            text = MotionLabel.text.slowingDown;
          } else {
            text = MotionLabel.text.accelerating;
          }
        } else {
          if (Math.abs(velocity) > this.thresholds.velocity) {
            text = MotionLabel.text.constantSpeed;
          } else {
            text = MotionLabel.text.stationary;
          }
        }

        this.motionLabel.innerHTML = text;
        show = true;
      }

      this.motionLabel.classList.toggle('hidden', !show);
    });
  }

  getAngle(p1, p2) {
    return Math.atan2(p2.y - p1.y, p2.x - p1.x);
  }

  calcPointData(point) {
    if (!this.parentLayer.visible) return;

    let segmentLength = CurveParams.segmentLength;
    let x = this.chartInstance.chartArea.left + point;
    x = this.getGraphFromScreenPosition({ x }).x;
    x = Math.min(Math.max(0, x), (this.pointsCount-1)*segmentLength);

    let undefinedToNaN = (number) => number === undefined ? NaN : number;

    let height = this.getGraphValue(this.chartInstance.data.datasets[1].data, x);
    height = undefinedToNaN(height);
    let currentPoint = { x: x, y: height };
    currentPoint = this.getScreenFromGraphPosition(currentPoint);

    let rect = this.canvas.getBoundingClientRect();
    currentPoint.y = rect.height - currentPoint.y;

    let pointData = {
      currentPoint: currentPoint,
      height: height.toFixed(0) + ' ' + this.chartInstance.data.datasets[0].units,
    };

    let t = undefinedToNaN(this.getGraphValue(this.chartInstance.data.datasets[0].data, x));
    let d = undefinedToNaN(this.getGraphValue(this.chartInstance.data.datasets[1].data, x));
    let v = undefinedToNaN(this.getGraphValue(this.chartInstance.data.datasets[2].data, x));
    let a = undefinedToNaN(this.getGraphValue(this.chartInstance.data.datasets[3].data, x));

    pointData.track = t.toFixed(0) + ' ' + this.chartInstance.data.datasets[1].units;
    pointData.displacement = d.toFixed(0) + ' ' + this.chartInstance.data.datasets[1].units;
    pointData.velocity = v.toFixed(0) + ' ' + this.chartInstance.data.datasets[2].units;
    pointData.acceleration = a.toFixed(0) + ' ' + this.chartInstance.data.datasets[3].units;

    this.tooltipModel = JSON.parse(JSON.stringify(tooltipModel));
    this.tooltipModel.body = this.chartData.data.datasets.map((d, i) => {
      return {
        "lines": [d.label + ": " + pointData[d.label.toLowerCase()]],
        hidden: this.chartInstance.getDatasetMeta(i).hidden
      }
    });

    return pointData
  }

  getScreenFromGraphPosition({x, y}) {
    let segmentLength = CurveParams.segmentLength;
    let { min, max } = chartData.options.scales.yAxes[0].ticks;
    let { left, right, top, bottom } = this.chartInstance.chartArea;
    let ax = x/((this.pointsCount-1)*segmentLength);
    let ay = (y-max)/(min-max);
    return { x: left+ax*(right-left), y: top+ay*(bottom-top) };
  }

  getGraphFromScreenPosition({x, y}) {
    let segmentLength = CurveParams.segmentLength;
    let { min, max } = chartData.options.scales.yAxes[0].ticks;
    let { left, right, top, bottom } = this.chartInstance.chartArea;
    let ax = (x-left)/(right-left);
    let ay = (y-top)/(bottom-top);
    return { x: ax*((this.pointsCount-1)*segmentLength), y: ay*(min-max)+max };
  }

  setRollerPosition() {
    if (!this.parentLayer.visible) return;
    let left = this.pos !== false ? this.pos : 0;

    let index = Math.floor(left / (this.scaleX.width / (this.pointsCount - 1))) || 0;
    if (index > this.pointsCount - 1) {
      index = this.pointsCount - 1;
    }
    let calcLength = (index, point) => {

      const getPointCoords = (i) => {
        return {
          x: this.chartInstance.scales["x-axis-0"].getPixelForTick(i),
          y: this.chartInstance.canvas.height - this.chartInstance.scales["y-axis-0"].getPixelForValue(this.chartInstance.data.datasets[0].data[i]) + 1
        }
      };
      let p = getPointCoords(index);
      let l = Math.sqrt(Math.pow(Math.abs(point.x - p.x), 2) + Math.pow(Math.abs(point.y - p.y), 2));
      if (index !== 0) {
        for (let i = 1; i <= index; i++) {
          let p1 = getPointCoords(i - 1);
          let p2 = getPointCoords(i);
          l += Math.sqrt(Math.pow(Math.abs(p2.x - p1.x), 2) + Math.pow(Math.abs(p2.y - p1.y), 2));
        }
      }
      return Math.round((l) / (this.chartInstance.scales["y-axis-0"].height / 600));
    };


    let pointData = this.calcPointData(left);

    (!this.dragging || this.dragging && this.isPlaying) && this.customTooltip.call(this, this.tooltipModel);

    let currentPoint = pointData.currentPoint;

    Events.fire("rollerCoaster_update", {
      track: pointData.track,
      velocity: pointData.velocity,
      acceleration: pointData.acceleration
    });

    let length = calcLength(index, currentPoint);

    !isNaN(length) && (this.rollerTip.innerHTML = length + " m");

    this.displays[this.chartInstance.data.datasets[1].label].innerHTML = '<span>' + this.chartInstance.data.datasets[1].symbol + ' = ' + pointData.displacement + '</span>';
    this.displays[this.chartInstance.data.datasets[2].label].innerHTML = '<span>' + this.chartInstance.data.datasets[2].symbol + ' = ' + pointData.velocity + '</span>'
    this.displays[this.chartInstance.data.datasets[3].label].innerHTML = '<span>' + this.chartInstance.data.datasets[3].symbol + ' = ' + pointData.acceleration + '</span>'

      // let angle = this.getAngle(currentPoint, tempPoint);
      this.rollers[0].style.right = (this.scaleX.width+this.scaleX.margins.right+this.scaleY.options.gridLines.tickMarkLength) + "px";
      this.rollers[0].style.bottom = (currentPoint.y - rH()/2) + "px";
      this.playbackLineY.style.bottom = (currentPoint.y - this.scaleY.margins.bottom) + "px";
      this.playbackLineX.style.height = (currentPoint.y - this.scaleY.margins.bottom + 2) + "px";
      // r.style.transform = "rotate(" + angle + "rad)";
      // if (i === 0) {
        // this.rollerTip.style.bottom = (currentPoint.y + rH() * 1.5) + "px";
        // this.rollerTip.style.left = currentPoint.x + rW() * Math.cos(angle) / 2 + "px";
        // angle < 0 && this.decreaseSpeed(Math.abs(angle * 180 / Math.PI / 100));
        // angle >= 0 && this.increaseSpeed(Math.abs(angle * 180 / Math.PI / 100));
      // }
    this.playbackLineX.style.left = currentPoint.x - this.chartInstance.chartArea.left + "px";
    this.playbackLineY.style.width = currentPoint.x - this.chartInstance.chartArea.left+2 + "px";
    if (this.isPlaying) {
      this.pos = left + (this.scaleX.width / 200 * this.speed) / 1.5;
      if (this.pos >= this.scaleX.width) {
        this.rollers.forEach(r => r.classList.add("no-transition"));
        setTimeout(() => {
          this.rollers.forEach(r => r.classList.remove("no-transition"));
        }, 200)
        this.pos = 0;
        this.speed = this.startSpeed;
      }
      requestAnimationFrame(this.setRollerPosition);
    }
  }

  increaseSpeed(val) {
    let max = 0.5;
    if ((this.speed) < max) {
      this.speed = this.speed + val / 40;
    } else {
      this.speed = max;
    }
  }

  decreaseSpeed(val) {
    let min = 0.1;
    if ((this.speed) > min) {
      this.speed = this.speed - val / 40;
    } else {
      this.speed = min;
    }
  }

  onDragStart(e) {
    let offsetX = e.offsetX || (e.touches[0].pageX - e.touches[0].target.getBoundingClientRect().left);
    this.dragging = this.chartInstance.getElementAtEvent(e)[0];
    if (this.dragging && (this.dragging._datasetIndex === 0 || this.dragging._datasetIndex === 1)) {
      e.stopPropagation();
      this.isDragging = true;
      this.scale = this.dragging['_yScale'].id;
      window.addEventListener("mousemove", this.onDrag);
      window.addEventListener("mouseup", this.onDragStop);
      window.addEventListener("touchmove", this.onDrag);
      window.addEventListener("touchend", this.onDragStop);
    } else {
      this.dragging = null;
    }

  }

  update() {
    this.updateTrackDataset();
    this.updateDisplacementDataset();
    this.updateVelocityDataset();
    this.updateAccelerationDataset();
    this.chartInstance.update(0);
  }

  setDerivativeGraph(graph, deltaGraph) {
    let subdivCount = CurveParams.subdivisionCount;

    let count = (this.pointsCount-1)*subdivCount+1;
    if (count < 2) {
        console.warn('the graph has less than 2 points');
        return;
    }

    let segmentLength = CurveParams.segmentLength;
    let deltaTime = segmentLength/subdivCount;

    deltaGraph[0] = { x: graph[0].x, y: (graph[1].y - graph[0].y) / deltaTime };

    for (let i = 1; i < count - 1; i++) {
        let [y1, y2] = [graph[i-1].y, graph[i + 1].y];
        deltaGraph[i] = { x: graph[i].x, y: (y2 - y1) / (2*deltaTime) };
    }

    deltaGraph[count-1] = { x: graph[count-1].x, y: (graph[count-1].y - graph[count-2].y) / deltaTime };
  }

  updateAccelerationDataset() {
    this.setDerivativeGraph(this.chartInstance.data.datasets[2].data, this.chartInstance.data.datasets[3].data);
  }

  updateVelocityDataset() {
    this.setDerivativeGraph(this.chartInstance.data.datasets[1].data, this.chartInstance.data.datasets[2].data);
  }

  updateTrackDataset() {
    let subdivCount = CurveParams.subdivisionCount;
    let chartValues = this.chartInstance.data.datasets[0].data;
    this.interpolateDataset(this.datasets[0], chartValues, this.pointsCount, subdivCount);
  }

  updateDisplacementDataset() {
    let subdivCount = CurveParams.subdivisionCount;
    let chartValues = this.chartInstance.data.datasets[1].data;
    this.interpolateDataset(this.datasets[1], chartValues, this.pointsCount, subdivCount);
  }

  interpolateDataset(sourceValues, targetValues, pointCount, subdivCount) {
    let segmentLength = CurveParams.segmentLength;
    let x = 0;

    for (let segment = 0; segment < pointCount-1; segment++) {
      let y0 = sourceValues[segment], y1 = sourceValues[segment+1];
      let tan0, tan1;
      if (segment === 0) {
        tan0 = y1-y0;
      } else {
        tan0 = (y1-sourceValues[segment-1])*0.5;
      }
      if (segment === pointCount-2) {
        tan1 = y1-y0;
      } else {
        tan1 = (sourceValues[segment+2]-y0)*0.5;
      }

      for (let i = 0; i < subdivCount; i++) {
        let t = i/subdivCount;
        let t2 = t*t, t3 = t*t*t;

        let y = (2*t3-3*t2+1)*y0 + (t3-2*t2+t)*tan0 + (-2*t3+3*t2)*y1 + (t3-t2)*tan1;
        targetValues[segment*subdivCount+i] = { x: (x++)*segmentLength/subdivCount, y: y };
      }
    }

    targetValues[(pointCount-1)*subdivCount] = { x: (x++)*segmentLength/subdivCount, y: sourceValues[pointCount-1] };
  }

  getGraphValue(dataset, x) {
    let segmentLength = CurveParams.segmentLength;
    let subdivCount = CurveParams.subdivisionCount;

    let indexf = x*subdivCount/segmentLength;
    let index0 = Math.floor(indexf);
    let index1 = index0+1;
    let [data0, data1] = [dataset[index0], dataset[index1]];
    if (x === (this.pointsCount-1)*segmentLength) return data0.y;
    if (!(data0 && data1)) return undefined;

    let x0 = data0.x, y0 = data0.y;
    let x1 = data1.x, y1 = data1.y;
    return y0+(y1-y0)*(x-x0)/(x1-x0);
  }

  onDrag(e) {
    let subdivCount = CurveParams.subdivisionCount;

    if (!this.dragging || e.target !== this.chartInstance.chart.canvas) return;
    let index = this.dragging['_index'];
    if (index%subdivCount !== 0) return;
    this.index = index/subdivCount;
    let offsetY = e.offsetY || (e.touches[0].pageY - e.touches[0].target.getBoundingClientRect().top);
    // alert("" + e.touches[0].pageY + ", " + e.touches[0].target.getBoundingClientRect().top)
    let val = this.chartInstance.scales[this.scale].getValueForPixel(offsetY < 1 ? 1 : offsetY);
    val <= 0 && (val = 0);
    val >= this.maxY && (val = this.maxY);
    this.datasets[this.dragging._datasetIndex][this.index] = val;
    this.update();
    // this.setTooltipPosition(this.dragging._model.x, this.dragging._model.y);
    !this.isPlaying && this.setRollerPosition();
  }

  onDragStop(e) {
    window.removeEventListener("mousemove", this.onDrag);
    window.removeEventListener("mouseup", this.onDragStop);
    this.dragging = null;
    // this.prerender();
    setTimeout(() => {
      this.isDragging = false;
    }, 500);
    !this.isPlaying && this.setRollerPosition();
  }

  setData(data) {

    let currentSize = this.getVWSize();
    Object.assign(this[currentSize], {
      x: data.x,
      y: data.y,
      width: data.width,
      height: data.height
    });

    Q3.data.layers.layers2D[this.parentLayer.uuid].objects[this.uuid][currentSize] = {};

    Object.assign(Q3.data.layers.layers2D[this.parentLayer.uuid].objects[this.uuid][currentSize], {
      x: data.x,
      y: data.y,
      width: data.width,
      height: data.height
    });
    this.update();
    this.updateSize();
    this.redraw();
    !this.isPlaying && this.setRollerPosition();

  }

  getBBox(w, h) {
    const size = this.getRenderPositionAndSize(w, h);

    return [size.x, size.y, size.x + size.w, size.y + size.h];
  }

  getRenderPositionAndSize(width, height) {
    let size = this.getVWSize();
    if (this[size]) {
      Object.assign(this, this[size]);
    }

    if (!width) {
      width = size.width;
    }
    if (!height) {
      height = size.height - 55;
    }

    // if (!Q3.editMode) {
    //   width = Q3.letterbox.offsetWidth / window.devicePixelRatio;
    //   height = (Q3.letterbox.offsetHeight - 55) / window.devicePixelRatio;
    // }

    let w = this.width * width * window.devicePixelRatio;
    let h = this.height * height * window.devicePixelRatio;

    if (w < 40) {
      w = 40;
    }
    if (h < 40) {
      h = 40;
    }

    const [x, y] = this._calcPosition(width, height);

    return {x, y, w, h};
  }

  redraw(width, height) {

    !width && (width = RenderManager.domElement.width / window.devicePixelRatio);
    !height && (height = (RenderManager.domElement.height) / window.devicePixelRatio);

    let currentSize = this.getVWSize();
    if (this[currentSize]) {
      Object.assign(this, this[currentSize]);
    }

    if (!Q3.editMode && this.inLetterbox !== false) {
      width = Q3.letterbox.offsetWidth / window.devicePixelRatio;
      height = (Q3.letterbox.offsetHeight) / window.devicePixelRatio;
    }

    let w = this.width * width * devicePixelRatio;
    let h = this.height * height * devicePixelRatio;

    // Object.assign(this.domElement.style, {
    //   width: w + 'px',
    //   height: h + 'px'
    // });

    // let size = this.calcSize(w, h);
    // this.inLetterbox === false && (size= {width: w + 'px', height: h + 'px'});
    // Object.assign(this.iframeElement.style, size);

    let x, y;

    [x, y] = this._calcPosition(width, height);

    Object.assign(this.domElement.style, {
      width: w + 'px',
      height: h + 'px',
      top: y + "px",
      left: x + "px"
    });

  }

  render(width, height) {
    if (!Q3.data.layers.layers2D[this.parentLayer.uuid] || this.disabled || Utils.queryParams.has("disable_2d")) return;

    if (!this.isMounted) {
      this.redraw(width, height);
      if (width > 0 && height > 0) {
        this.isMounted = true;
      }
    }
  }

  delete() {
    this.handleListeners(false);
    this.isPlaying = false;
    this.isDeleted = true;
    cancelAnimationFrame(this.animationFrame);
    this.parentLayer.objects.splice(this.parentLayer.objects.indexOf(this), 1);
    this.parentLayer.domElement.removeChild(this.domElement);

    delete this.domElement;
    let tooltip = document.getElementById("chartjs-tooltip");
    if (tooltip) tooltip.remove();

    if (Q3.selected === this) {
      Q3.selected = null;
      Events.fire('selectchange');
    }

  }


  clone() {

    const roller = new RollerCoaster({
        src: this.src,
        x: this.x + 0.01,
        y: this.y + 0.01,
      },
      this.parentLayer,
      THREE.Math.generateUUID()
    );

    Q3.data.layers.layers2D[roller.parentLayer.uuid].objects[roller.uuid] = {
      type: 'picture',
      src: roller.filename,
      x: roller.x,
      y: roller.y,
      targetUuid: roller.targetUuid
    };

    this.parentLayer.objects.splice(this.parentLayer.objects.indexOf(this), 0, roller);
    this.parentLayer.objects.forEach((o, i) => o.index = i);

    return roller;

  }

  hide() {

    this.domElement.classList.add('q3-picture-occluded');

  }

  show() {

    this.domElement.classList.remove('q3-picture-occluded');

  }
  set pos(val) {
    this._pos = isNaN(val) ? 0 : val;
  }
  get pos() {
    return this._pos;
  }

}

export default RollerCoaster;
export {RollerCoaster};

const awaitLib = (function () {
    let promise;
    return function () {
        return promise = (promise || new Promise(resolve => {
            console.warn("Q3: Chart not initialized. Begun downloading.");
            injectJS("/js/chart.libs.js").then(function () {
                console.info("Q3: Chart downloaded.");
                resolve();
            });
        }));
    };
})();